export default "__VITE_ASSET__BTRt_qY7__"